
import { FormState__startLoading, FormState_get_empty, RequestedValue$1 } from "../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { deleteCalendarToken, regenerateCalendarToken, createCalendarToken, getCalendarToken, getCalendarData } from "../Requests/Calendar.js";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export function init() {
    return [new State(new RequestedValue$1(0, []), new RequestedValue$1(0, []), FormState_get_empty()), Cmd_batch(ofArray([getCalendarData((Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(1, [Item_1]))), getCalendarToken((Item_2) => (new Msg(3, [Item_2])), (Item_3) => (new Msg(4, [Item_3])))]))];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [state, Cmd_none()];
        case 2:
            return [new State(state.CalendarData, new RequestedValue$1(0, []), state.FormState), getCalendarToken((Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(4, [Item_1])))];
        case 3:
            return [new State(state.CalendarData, new RequestedValue$1(1, [msg.fields[0]]), state.FormState), Cmd_none()];
        case 4:
            return [new State(state.CalendarData, new RequestedValue$1(1, [undefined]), state.FormState), Cmd_none()];
        case 5:
            return [new State(state.CalendarData, state.CalendarToken, FormState__startLoading(state.FormState)), createCalendarToken((Item_2) => (new Msg(6, [Item_2])), (Item_3) => (new Msg(7, [Item_3])))];
        case 6: {
            const response = msg.fields[0];
            if (response.tag === 0) {
                return [new State(state.CalendarData, new RequestedValue$1(1, [response.fields[0]]), FormState_get_empty()), Cmd_none()];
            }
            else {
                return [new State(state.CalendarData, state.CalendarToken, FormState_get_empty()), Cmd_none()];
            }
        }
        case 7:
            return [new State(state.CalendarData, state.CalendarToken, FormState_get_empty()), Cmd_none()];
        case 8:
            return [new State(state.CalendarData, state.CalendarToken, FormState__startLoading(state.FormState)), regenerateCalendarToken((Item_4) => (new Msg(9, [Item_4])), (Item_5) => (new Msg(10, [Item_5])))];
        case 9: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 0) {
                return [new State(state.CalendarData, new RequestedValue$1(1, [response_1.fields[0]]), FormState_get_empty()), Cmd_none()];
            }
            else {
                return [new State(state.CalendarData, state.CalendarToken, FormState_get_empty()), Cmd_none()];
            }
        }
        case 10:
            return [new State(state.CalendarData, state.CalendarToken, FormState_get_empty()), Cmd_none()];
        case 11:
            return [new State(state.CalendarData, state.CalendarToken, FormState__startLoading(state.FormState)), deleteCalendarToken((Item_6) => (new Msg(12, [Item_6])), (Item_7) => (new Msg(13, [Item_7])))];
        case 12:
            if (msg.fields[0].tag === 0) {
                return [new State(state.CalendarData, new RequestedValue$1(1, [undefined]), FormState_get_empty()), Cmd_none()];
            }
            else {
                return [new State(state.CalendarData, state.CalendarToken, FormState_get_empty()), Cmd_none()];
            }
        case 13:
            return [new State(state.CalendarData, state.CalendarToken, FormState_get_empty()), Cmd_none()];
        default:
            return [new State(new RequestedValue$1(1, [msg.fields[0]]), state.CalendarToken, state.FormState), Cmd_none()];
    }
}

